import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import { IconButton } from 'components/core/Button';
// Models
import mPartner from 'models/cpm/partner';
// Custom
import {
  listRowSpecsShape,
  cpmPartnersDataShape,
} from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const PartnerRow = React.forwardRef(({
  partner, rowSpecs, onDisplay, onEdit,
}, ref) => {
  // Handlers
  const handleDisplay = () => {
    onDisplay(partner);
  };

  const handleEdit = () => {
    onEdit(partner);
  };

  return (
    <TableRow
      ref={ref}
      element={partner}
      rowSpecs={rowSpecs}
      actions={[
        <IconButton
          key="bDisplay"
          iconId="btnInfo"
          tooltipId="tooltip.displayPartnerInfo"
          onClick={handleDisplay}
        />,
        <IconButton
          key="bEdit"
          iconId="btnEdit"
          tooltipId="tooltip.editPartner"
          onClick={handleEdit}
        />,
      ]}
    >
      {/* ----- Name ----- */}
      <TableCell
        className={classnames({
          'table-first-details': rowSpecs.withDetails,
        })}
      >
        <TruncatedTooltipText>{partner.name}</TruncatedTooltipText>
      </TableCell>
      {/* ----- Address ----- */}
      <TableCell className="hidden-md-down">
        <TruncatedTooltipText>
          {mPartner.getAddressDesc(partner)}
        </TruncatedTooltipText>
      </TableCell>
      {/* ----- Email for commission invoices ----- */}
      <TableCell className="hidden-md-down">
        <TruncatedTooltipText>
          {mPartner.getEmailForCommissionInvoices(partner)}
        </TruncatedTooltipText>
      </TableCell>
      {/* ----- Invoice identifier ----- */}
      <TableCell className="hidden-sm-down">
        <TruncatedTooltipText>
          {mPartner.getInvoiceIdentifier(partner)}
        </TruncatedTooltipText>
      </TableCell>
    </TableRow>
  );
});

PartnerRow.displayName = 'PartnerRow';

PartnerRow.propTypes = {
  partner: cpmPartnersDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  onDisplay: PropTypes.func,
  onEdit: PropTypes.func,
};

PartnerRow.defaultProps = {
  onDisplay: null,
  onEdit: null,
};

module.exports = PartnerRow;



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/partner/PartnerRow.js